const CONSTANTS = {
    MODULE_ID: "chat-portrait",
    PATH: `modules/chat-portrait/`,
    INV_UNIDENTIFIED_BOOK: `modules/chat-portrait/assets/inv-unidentified-book.png`,
    DEF_TOKEN_IMG_NAME: "mystery-man",
    DEF_TOKEN_IMG_PATH: "icons/svg/mystery-man.svg",
};
CONSTANTS.PATH = `modules/${CONSTANTS.MODULE_ID}/`;
export default CONSTANTS;
